import React, { Suspense } from 'react'

const EditBtn = (callfunc, getFormPath, ReadOnly= false, CRUDType="UPDATE") => {
    return ([
        {
            tooltip: 'Edit Record',
            icon: 'create_filled',
            render: rowData => {
                const Form = React.lazy(() => getFormPath());
                return (
                    <Suspense fallback={<div>Loading...</div>}>
                        <Form
                            orientation="Horizontal"
                            defaultValues={rowData}
                            CRUDType={CRUDType}
                            ReadOnly={ReadOnly}
                            callback={callfunc}
                        />
                    </Suspense>
                )
            }
        }
    ])
}

export default EditBtn